import styled from 'styled-components';

export const ErrorBoundaryStyle = styled.div`
  text-align: center;
`;
